import { Text } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import type { MRT_ColumnDef, MRT_RowData } from "mantine-react-table-open";
import { MantineIconCell } from "../../../../../../mantine/mrt/components/cell/MantineIconCell";
import { THEME_VARS } from "../../../../../../utils/constants";
import { getMeterTableErrorText } from "../getMeterTableErrorText";

export function getMeterNumberColumn<T extends MRT_RowData>(
  getCellError: (
    rowIndex: number,
    accessorKey: keyof T
  ) => Array<string> | null | undefined
): MRT_ColumnDef<T> {
  return {
    accessorKey: "number",
    header: "Zählernummer",
    Cell: ({ row }) => {
      const cellError = getCellError(row.index, "number");
      return (
        <div>
          {row.original.number}
          {cellError && (
            <MantineIconCell
              iconColor={THEME_VARS.error[6]}
              IconComponent={IconAlertTriangle}
              renderedCellValue={
                <Text c="error">{getMeterTableErrorText(cellError[0])}</Text>
              }
            />
          )}
        </div>
      );
    }
  };
}
